<template>
  <div class="bg-white mx-2 cs-dropdown-select dropdown">
    <button
      @click="state.isVisible = !state.isVisible"
      type="button"
      aria-expanded="false"
      aria-haspopup="true"
      class="btn dropdown-toggle"
    >
      {{ selectedLabel || label }}
    </button>
    <div
      v-if="options"
      :class="{ 'd-block': state.isVisible }"
      class="dropdown-menu"
    >
      <div
        v-for="(item, index) in options"
        @click="selecteActive(item)"
        :key="index"
        role="menuitem"
        :class="{
          active: selectedItems.length
            ? selectedItems.includes(item)
            : item.label == label
        }"
        target="_self"
        class="dropdown-item"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, computed } from "vue"

export default {
  props: {
    options: {
      type: Array,
      deep: true
    },
    selectedLabel: String,
    selectedItems: {
      type: Array,
      default: () => []
    }
  },
  emits: ["itemClick"],
  setup(props, { emit }) {
    const state = reactive({
      isVisible: false,
      selectedOption: null
    })

    const label = computed(() => {
      return state.selectedOption ? state.selectedOption.label : ""
    })

    const selecteActive = (item) => {
      state.selectedOption = item
      state.isVisible = false
      emit("itemClick", item)
    }

    return {
      state,
      label,
      selecteActive
    }
  }
}
</script>
